/** MEMORY_STORM — one shouted line before the deck starts pitching (flavour allowed by STORY_ADAPTATION P2). */
import type { DialogueData } from '@/core/types/contracts';
import { SPEAKER } from '../actors';
import { linear, narr, say } from './util';

export const STORM_DIALOGUES: DialogueData[] = [
  linear('prologue-storm-intro', [
    narr('黑夜。一个月里唯一一次大的风浪。'),
    say(SPEAKER.sailor, '收帆！都抓紧了！'),
  ]),
];
